import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import _Array$isArray from "@babel/runtime-corejs3/core-js/array/is-array";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _flatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _URL from "@babel/runtime-corejs3/core-js/url";
import { sortObjectByKeys, filterObjectByKeys } from "./object_extension.js";
function normalizeQueryFacets(selectedFacets) {
  var _context;
  var params = '';
  _forEachInstanceProperty(_context = _Object$keys(selectedFacets)).call(_context, function (k) {
    if (selectedFacets[k] instanceof Array && selectedFacets[k].length > 1) {
      selectedFacets[k] = selectedFacets[k].join(',');
    }
    params += "".concat(k, "=").concat(selectedFacets[k], "&");
  });
  return _sliceInstanceProperty(params).call(params, 0, -1);
}
export function defineUrl(_ref) {
  var filterRankSlugs = _ref.filterRankSlugs,
    altResourceSlug = _ref.altResourceSlug,
    specificSlugForFacetMapping = _ref.specificSlugForFacetMapping,
    pathFragment = _ref.pathFragment;
  return function defineApplyUrl(selectFacets) {
    var sortedFacets = sortObjectByKeys(selectFacets, filterRankSlugs);
    var altResourceFacetSlug = sortedFacets[altResourceSlug];
    delete sortedFacets[altResourceSlug];
    var rankedFilters = filterObjectByKeys(sortedFacets, filterRankSlugs);
    var rankKey = _Object$keys(rankedFilters)[0];
    var path = '';
    var rankKeySpecificSlug = '';
    if (typeof rankKey !== 'undefined' && sortedFacets[rankKey].length <= 1) {
      rankKeySpecificSlug = (specificSlugForFacetMapping[rankKey] || {})[sortedFacets[rankKey]];
      if (typeof rankKeySpecificSlug !== 'undefined' && rankKeySpecificSlug) {
        path += rankKeySpecificSlug;
      } else {
        path += "".concat(sortedFacets[rankKey], "-");
      }
      delete sortedFacets[rankKey];
    }
    if (typeof rankKeySpecificSlug === 'undefined' || !rankKeySpecificSlug) {
      path += typeof altResourceFacetSlug === 'undefined' ? pathFragment : altResourceFacetSlug;
    }
    var paramString = decodeURIComponent(normalizeQueryFacets(sortedFacets));
    if (paramString.length) {
      path += "?".concat(paramString);
    }
    return path.length ? "/fashion/".concat(path) : 'javascript:void(0)';
  };
}
function transformFacetsParams(facets) {
  return function transformParams(selectedFacets) {
    var _context2;
    var facetsParams = {};
    _forEachInstanceProperty(_context2 = _Object$keys(selectedFacets)).call(_context2, function (slug) {
      var facet = _findInstanceProperty(facets).call(facets, function (facetObj) {
        return facetObj.seo_slug === slug;
      });
      if (facet) {
        var _context3;
        var values = _filterInstanceProperty(_context3 = _valuesInstanceProperty(facet)).call(_context3, function (val) {
          var _context4;
          var selectedFacet = selectedFacets[facet.seo_slug];
          if (!selectedFacet) return false;
          return _Array$isArray(selectedFacet) ? _includesInstanceProperty(_context4 = _flatInstanceProperty(selectedFacet).call(selectedFacet)).call(_context4, val.seo_slug) : _includesInstanceProperty(selectedFacet).call(selectedFacet, val.seo_slug);
        });
        if (values) {
          if (values.length > 1) {
            facetsParams[facet.key] = _mapInstanceProperty(values).call(values, function (val) {
              return val.value;
            });
          } else {
            facetsParams[facet.key] = values[0].value;
          }
        }
      }
    });
    return facetsParams;
  };
}
export function defineFilterUrl(_ref2) {
  var facets = _ref2.facets,
    facetFilterCounterUrl = _ref2.facetFilterCounterUrl;
  var transformParams = transformFacetsParams(facets);
  return function filterCounterUrl(selectedFacets) {
    var _context5;
    var url = new _URL(facetFilterCounterUrl);
    var facetsParams = transformParams(selectedFacets);
    _forEachInstanceProperty(_context5 = _Object$keys(facetsParams)).call(_context5, function (slug) {
      var values = facetsParams[slug] instanceof Array ? facetsParams[slug].join(',') : facetsParams[slug];
      url.searchParams.append(slug, values);
    });
    return url.toString();
  };
}